import { AddPaymentMethodModal } from 'components/add-payment-method-modal';
import { AddPaymentMethodModalRedesign } from 'components/add-payment-method-modal-redesign';
import { usePaymentCheckoutRedesignExperiment } from 'experiments/use-payment-checkout-redesign-experiment';

export default function AddCard() {
  const isPaymentRedesignEnabled = usePaymentCheckoutRedesignExperiment();

  return isPaymentRedesignEnabled ? <AddPaymentMethodModalRedesign /> : <AddPaymentMethodModal />;
}
